/* Livia Azzurro — sticky nav + mega-menu + predictive search (a11y-aware) */
(function () {
  if (typeof window === "undefined") return;

  var nav;
  var scrollLockY = 0;
  var touchMoveBlocker = null;

  function lockPageScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add("la-nav-open");
    document.body.style.position = "fixed";
    document.body.style.top = "-" + scrollLockY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove("la-nav-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    window.scrollTo(0, scrollLockY);
  }

  function update() {
    if (!nav) return;
    if (window.scrollY > 24) nav.classList.add("is-scrolled");
    else nav.classList.remove("is-scrolled");
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function init() {
    nav = document.querySelector(".livia-nav");
    if (!nav) return;
    update();
    window.addEventListener("scroll", update, { passive: true });

    /* Mobile menu toggle */
    var burger = nav.querySelector("[data-la-nav-toggle]");
    var drawer = nav.querySelector("[data-la-nav-drawer]");

    function isDrawerOpen() {
      return drawer && !drawer.hasAttribute("hidden");
    }

    function closeDrawer() {
      if (!drawer || drawer.hasAttribute("hidden")) return;
      drawer.setAttribute("hidden", "");
      if (burger) burger.setAttribute("aria-expanded", "false");
      unlockPageScroll();
      if (touchMoveBlocker) {
        document.removeEventListener("touchmove", touchMoveBlocker);
        touchMoveBlocker = null;
      }
    }

    function openDrawer() {
      if (!drawer) return;
      closeAll();
      closeSearch();
      drawer.removeAttribute("hidden");
      if (burger) burger.setAttribute("aria-expanded", "true");
      lockPageScroll();
      if (!touchMoveBlocker) {
        touchMoveBlocker = function (e) {
          if (drawer.contains(e.target)) return;
          e.preventDefault();
        };
        document.addEventListener("touchmove", touchMoveBlocker, { passive: false });
      }
    }

    if (burger && drawer) {
      burger.addEventListener("click", function () {
        if (isDrawerOpen()) closeDrawer();
        else openDrawer();
      });
    }

    /* Mega-menu (hover + click + keyboard) */
    var triggers = nav.querySelectorAll("[data-la-mega]");
    var panels = nav.querySelectorAll("[data-la-mega-panel]");
    var closeTimer = null;

    function closeAll() {
      panels.forEach(function (p) { p.setAttribute("hidden", ""); });
      triggers.forEach(function (t) { t.setAttribute("aria-expanded", "false"); });
    }
    function openPanel(key) {
      closeAll();
      var panel = nav.querySelector('[data-la-mega-panel="' + key + '"]');
      var trigger = nav.querySelector('[data-la-mega="' + key + '"]');
      if (panel) panel.removeAttribute("hidden");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
    }
    function isAnyOpen() {
      return Array.prototype.some.call(panels, function (p) { return !p.hasAttribute("hidden"); });
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 180);
    }
    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    triggers.forEach(function (t) {
      t.setAttribute("aria-expanded", "false");
      var key = t.getAttribute("data-la-mega");
      t.addEventListener("mouseenter", function () { cancelClose(); openPanel(key); });
      t.addEventListener("focus", function () { cancelClose(); openPanel(key); });
      t.addEventListener("mouseleave", scheduleClose);
      t.addEventListener("click", function (e) {
        e.preventDefault();
        var expanded = t.getAttribute("aria-expanded") === "true";
        if (expanded) closeAll(); else openPanel(key);
      });
    });
    panels.forEach(function (p) {
      p.addEventListener("mouseenter", cancelClose);
      p.addEventListener("mouseleave", scheduleClose);
    });

    /* -------- Predictive search -------- */
    var searchToggle = nav.querySelector("[data-la-search-toggle]");
    var searchPanel = nav.querySelector("[data-la-search-panel]");
    var searchInput = nav.querySelector("[data-la-search-input]");
    var searchResults = nav.querySelector("[data-la-search-results]");
    var searchClose = nav.querySelector("[data-la-search-close]");
    var searchTimer = null;
    var searchAbort = null;

    function openSearch() {
      if (!searchPanel) return;
      closeAll(); /* zamknij mega menu jeśli otwarte */
      searchPanel.hidden = false;
      if (searchToggle) searchToggle.setAttribute("aria-expanded", "true");
      setTimeout(function () { searchInput && searchInput.focus(); }, 40);
    }
    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = true;
      if (searchToggle) searchToggle.setAttribute("aria-expanded", "false");
      if (searchInput) searchInput.value = "";
      if (searchResults) searchResults.innerHTML = "";
      if (searchAbort) { try { searchAbort.abort(); } catch (e) {} searchAbort = null; }
    }
    function isSearchOpen() { return searchPanel && !searchPanel.hidden; }

    if (searchToggle && searchPanel) {
      searchToggle.setAttribute("aria-expanded", "false");
      searchToggle.addEventListener("click", function () {
        if (isSearchOpen()) closeSearch(); else openSearch();
      });
    }
    if (searchClose) searchClose.addEventListener("click", closeSearch);

    function renderResults(data, q) {
      var results = (data && data.resources && data.resources.results) || {};
      var products = results.products || [];
      var collections = results.collections || [];
      var articles = results.articles || [];
      var pages = results.pages || [];

      if (!products.length && !collections.length && !articles.length && !pages.length) {
        searchResults.innerHTML =
          '<p class="livia-nav__search-empty">Brak wyników dla &laquo;' + escapeHtml(q) + '&raquo;.</p>';
        return;
      }

      var html = "";

      if (products.length) {
        html += '<div class="livia-nav__search-group">';
        html += '<p class="la-eyebrow livia-nav__search-group-title">Produkty</p>';
        html += '<ul class="livia-nav__search-products">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || "");
          var priceText = "";
          if (typeof p.price === "string" && p.price) priceText = p.price;
          else if (typeof p.price === "number") priceText = (p.price / 100).toFixed(2);
          html += '<li><a href="' + escapeHtml(p.url) + '" class="livia-nav__search-product">';
          if (img) {
            html += '<span class="livia-nav__search-product-img"><img src="' + escapeHtml(img) +
                    '" alt="" loading="lazy" decoding="async" width="48" height="48"></span>';
          } else {
            html += '<span class="livia-nav__search-product-img"></span>';
          }
          html += '<span class="livia-nav__search-product-text">';
          html += '<span class="livia-nav__search-product-title">' + escapeHtml(p.title) + "</span>";
          if (priceText) {
            html += '<span class="livia-nav__search-product-price">' + escapeHtml(priceText) + "</span>";
          }
          html += "</span></a></li>";
        });
        html += "</ul></div>";
      }

      if (collections.length) {
        html += '<div class="livia-nav__search-group">';
        html += '<p class="la-eyebrow livia-nav__search-group-title">Kolekcje</p>';
        html += '<ul class="livia-nav__search-list">';
        collections.forEach(function (c) {
          html += '<li><a href="' + escapeHtml(c.url) + '" class="livia-nav__search-link">' +
                  escapeHtml(c.title) + "</a></li>";
        });
        html += "</ul></div>";
      }

      if (articles.length) {
        html += '<div class="livia-nav__search-group">';
        html += '<p class="la-eyebrow livia-nav__search-group-title">Journal</p>';
        html += '<ul class="livia-nav__search-list">';
        articles.forEach(function (a) {
          html += '<li><a href="' + escapeHtml(a.url) + '" class="livia-nav__search-link">' +
                  escapeHtml(a.title) + "</a></li>";
        });
        html += "</ul></div>";
      }

      if (pages.length) {
        html += '<div class="livia-nav__search-group">';
        html += '<p class="la-eyebrow livia-nav__search-group-title">Strony</p>';
        html += '<ul class="livia-nav__search-list">';
        pages.forEach(function (pg) {
          html += '<li><a href="' + escapeHtml(pg.url) + '" class="livia-nav__search-link">' +
                  escapeHtml(pg.title) + "</a></li>";
        });
        html += "</ul></div>";
      }

      html += '<a href="/search?q=' + encodeURIComponent(q) +
              '" class="livia-nav__search-all">Zobacz wszystkie wyniki →</a>';

      searchResults.innerHTML = html;
    }

    function performSearch(q) {
      if (!searchResults) return;
      if (searchAbort) { try { searchAbort.abort(); } catch (e) {} }
      searchAbort = window.AbortController ? new AbortController() : null;
      var opts = searchAbort ? { signal: searchAbort.signal } : {};

      searchResults.innerHTML = '<p class="livia-nav__search-loading">Szukanie…</p>';

      var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
                "&resources[type]=product,collection,article,page" +
                "&resources[limit]=6" +
                "&resources[options][unavailable_products]=last" +
                "&resources[options][fields]=title,product_type,variants.title,vendor";

      fetch(url, opts)
        .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); })
        .then(function (data) { renderResults(data, q); })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          searchResults.innerHTML =
            '<p class="livia-nav__search-empty">Nie można połączyć z wyszukiwarką. Spróbuj ponownie.</p>';
        });
    }

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        var q = (searchInput.value || "").trim();
        if (searchTimer) clearTimeout(searchTimer);
        if (q.length < 2) {
          if (searchResults) {
            searchResults.innerHTML = q.length === 0
              ? '<p class="livia-nav__search-hint">Wpisz min. 2 znaki, aby zobaczyć podpowiedzi.</p>'
              : "";
          }
          if (searchAbort) { try { searchAbort.abort(); } catch (e) {} searchAbort = null; }
          return;
        }
        searchTimer = setTimeout(function () { performSearch(q); }, 220);
      });
    }

    /* Click outside search panel zamyka (ale nie klik na toggle/panel) */
    document.addEventListener("click", function (e) {
      if (!isSearchOpen()) return;
      if (!searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
        closeSearch();
      }
    });

    /* Escape: drawer → search → mega */
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (isDrawerOpen()) { closeDrawer(); burger && burger.focus(); return; }
      if (isSearchOpen()) { closeSearch(); searchToggle && searchToggle.focus(); return; }
      if (isAnyOpen()) {
        closeAll();
        var first = triggers[0];
        if (first) first.focus();
      }
    });

    document.addEventListener("focusin", function (e) {
      if (isAnyOpen() && !nav.contains(e.target)) closeAll();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
